module.exports = __webpack_public_path__ + "img/应用场景_政府考察.2248143a.png";